// @ts-nocheck
const environment = process.env.NODE_ENV === "development" ? {
  apiUrl: process.env.REACT_APP_STEDDI_API_URL!,
  scriveUrl: process.env.REACT_APP_SCRIVE_URL,
  authUrl: process.env.REACT_APP_AUTH_URL
} : {
  apiUrl: window.MyConfig.apiUrl,
  scriveUrl: window.MyConfig.scriveUrl,
  authUrl: window.MyConfig.authUrl
}

export default environment